"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Card_1 = __importDefault(require("@mui/material/Card"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var react_i18next_1 = require("react-i18next");
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Integrations_module_css_1 = __importDefault(require("../Integrations.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var uuid_1 = require("uuid");
var material_2 = require("@mui/material");
var ReportLink = function (_a) {
    var url = _a.url, name = _a.name, width = _a.width, height = _a.height, mode = _a.mode, isNew = _a.isNew, index = _a.index, onUrlChange = _a.onUrlChange, onNameChange = _a.onNameChange, onWidthChange = _a.onWidthChange, onHeightChange = _a.onHeightChange, onDelete = _a.onDelete, webCaptureIntegrationId = _a.webCaptureIntegrationId, uuid = _a.uuid, shouldFetchNew = _a.shouldFetchNew, onStatusChange = _a.onStatusChange;
    var _b = (0, react_1.useState)(null), imageUrl = _b[0], setImageUrl = _b[1];
    var _c = (0, react_1.useState)(null), urlStatus = _c[0], setUrlStatus = _c[1];
    var _d = (0, react_1.useState)(false), setStatusError = _d[1];
    var _e = (0, react_1.useState)(false), setImageError = _e[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _f = (0, react_1.useState)(false), isLoadingImage = _f[0], setIsLoadingImage = _f[1];
    var timerIdRef = (0, react_1.useRef)(null);
    var _g = (0, react_1.useState)(!url), isUrlEmpty = _g[0], setIsUrlEmpty = _g[1];
    var _h = (0, react_1.useState)(!name), isNameEmpty = _h[0], setIsNameEmpty = _h[1];
    var _j = (0, react_1.useState)(!width), isWidthEmpty = _j[0], setIsWidthEmpty = _j[1];
    var _k = (0, react_1.useState)(!height), isHeightEmpty = _k[0], setIsHeightEmpty = _k[1];
    var pollInterval = 30000;
    var fetchResourceStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, resourceStatus, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!webCaptureIntegrationId || !uuid) {
                        console.error("Integration ID or UUID is missing.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 10, , 11]);
                    return [4 /*yield*/, fetch("/api/integration/".concat(webCaptureIntegrationId, "/status"))];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 8];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    resourceStatus = data.resources.find(function (r) { return r.uuid === uuid; });
                    if (!resourceStatus) return [3 /*break*/, 7];
                    setUrlStatus(resourceStatus.status);
                    onStatusChange(uuid, resourceStatus.status);
                    if (!(resourceStatus.status === 425)) return [3 /*break*/, 4];
                    setTimeout(fetchResourceStatus, pollInterval);
                    return [3 /*break*/, 7];
                case 4:
                    if (!(resourceStatus.status === 200)) return [3 /*break*/, 6];
                    return [4 /*yield*/, fetchResourceImage()];
                case 5:
                    _a.sent();
                    clearInterval(timerIdRef.current);
                    return [3 /*break*/, 7];
                case 6:
                    clearInterval(timerIdRef.current);
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    setUrlStatus(response.status);
                    clearInterval(timerIdRef.current);
                    _a.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    error_1 = _a.sent();
                    console.error("Error fetching integration status:", error_1);
                    setStatusError(true);
                    clearInterval(timerIdRef.current);
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var fetchResourceImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, objectUrl, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    setIsLoadingImage(true);
                    return [4 /*yield*/, fetch("/api/integration/".concat(webCaptureIntegrationId, "/").concat(uuid))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    objectUrl = URL.createObjectURL(blob);
                    setImageUrl(objectUrl);
                    setImageError(false);
                    if (timerIdRef.current) {
                        clearInterval(timerIdRef.current);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    if (response.status === 500) {
                        setTimeout(fetchResourceImage, 30000);
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    console.error("Error fetching resource image:", error_2);
                    setImageError(true);
                    setIsLoadingImage(false);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!timerIdRef.current && (shouldFetchNew && (mode === "new" || (mode === "edit" && isNew)))) {
            fetchResourceStatus();
            timerIdRef.current = setInterval(fetchResourceStatus, pollInterval);
        }
        return function () {
            clearInterval(timerIdRef.current);
            timerIdRef.current = null;
        };
    }, [shouldFetchNew,]);
    (0, react_1.useEffect)(function () {
        if (!timerIdRef.current && (mode === "edit" && !isNew)) {
            fetchResourceStatus();
            timerIdRef.current = setInterval(fetchResourceStatus, pollInterval);
        }
        return function () {
            clearInterval(timerIdRef.current);
            timerIdRef.current = null;
        };
    }, [isNew]);
    var getImageTooltipText = function () {
        if (isLoadingImage || urlStatus === 425) {
            return t("Resource is being generated.");
        }
        else if (!imageUrl) {
            return t("Resource image will be shown here.");
        }
        else {
            return "";
        }
    };
    var getStatusTooltipText = function (status) {
        if ((urlStatus === 200 && imageUrl)) {
            return t("The integration is working as expected.");
        }
        switch (status) {
            case 425:
                return t("Resource is being generated.");
            case 200:
                return t("The integration is working as expected.");
            case 400:
                return t("The given URL is invalid.");
            case 403:
                return t("Login failed / potential for invalid credentials.");
            case 404:
                return t("The URL no longer exists.");
            case 500:
                return t("Server error, try saving again. If the error remains please contact +45 71 92 62 22 or support@nordicscreen.com");
            default:
                return t("Resource status will be shown here.");
        }
    };
    var statusIcon = function () {
        var tooltipText = getStatusTooltipText(urlStatus);
        if (urlStatus === 425) {
            return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faHourglass, style: { color: "var(--info-color)", width: "15px", height: "15px" }, title: tooltipText });
        }
        else if (urlStatus === 200) {
            return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleCheck, style: { color: "#92BF00" }, title: tooltipText });
        }
        else if ([400, 403, 404, 500].includes(urlStatus)) {
            return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimesCircle, style: { color: "#A71535" }, title: tooltipText });
        }
        else {
            return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCircleQuestion, style: { color: "var(--info-color)" }, title: tooltipText });
        }
    };
    var handleDeleteClick = function () {
        onDelete(index);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: Integrations_module_css_1.default.reportLinkRow },
            react_1.default.createElement("div", { className: Integrations_module_css_1.default.inputGroup, style: { flexGrow: 1 } },
                react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isUrlEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                react_1.default.createElement(q_play_components_1.Input, { value: url || "", onChange: function (event) {
                        onUrlChange(index, event.target.value);
                        setIsUrlEmpty(event.target.value.trim() === "");
                    }, className: Integrations_module_css_1.default.urlInput, placeholder: "URL: ", dataCy: "webCaptureUrlInput" })),
            react_1.default.createElement("div", { className: Integrations_module_css_1.default.inputGroup },
                react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isNameEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                react_1.default.createElement(q_play_components_1.Input, { value: name || "", onChange: function (event) {
                        onNameChange(index, event.target.value);
                        setIsNameEmpty(event.target.value.trim() === "");
                    }, className: Integrations_module_css_1.default.nameInput, placeholder: t("Name"), dataCy: "webCaptureNameInput" })),
            react_1.default.createElement("div", { className: Integrations_module_css_1.default.inputGroup },
                react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isWidthEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                react_1.default.createElement(q_play_components_1.Input, { type: "number", value: width || "", onChange: function (event) {
                        onWidthChange(index, event.target.value);
                        setIsWidthEmpty(event.target.value.trim() === "");
                    }, className: Integrations_module_css_1.default.widthInput, placeholder: t("Width"), dataCy: "webCaptureWidthInput" })),
            react_1.default.createElement("div", { style: { width: "5px", textAlign: "center" } }, "x"),
            react_1.default.createElement("div", { className: Integrations_module_css_1.default.inputGroup },
                react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isHeightEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                react_1.default.createElement(q_play_components_1.Input, { type: "number", value: height || "", onChange: function (event) {
                        onHeightChange(index, event.target.value);
                        setIsHeightEmpty(event.target.value.trim() === "");
                    }, className: Integrations_module_css_1.default.heightInput, placeholder: t("Height"), dataCy: "webCaptureHeightInput" })),
            react_1.default.createElement("div", { className: Integrations_module_css_1.default.statusAndImage },
                statusIcon(),
                react_1.default.createElement("div", { className: Integrations_module_css_1.default.imageContainer }, imageUrl && urlStatus === 200
                    ? react_1.default.createElement("img", { src: imageUrl, alt: "Resource", className: Integrations_module_css_1.default.resourceImage })
                    : isLoadingImage || urlStatus === 425
                        ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSpinner, spin: true, style: { color: "var(--info-color)" }, title: getImageTooltipText() })
                        : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faImageLandscape, className: Integrations_module_css_1.default["landscape-icon"], title: getImageTooltipText() }))),
            react_1.default.createElement("button", { onClick: handleDeleteClick, className: "btn btn-link", style: { color: "var(--info-color)", position: "relative", top: "5px", right: "-7px" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan })))));
};
var EditableIntegrationName = function (_a) {
    var integrationName = _a.integrationName, setIntegrationName = _a.setIntegrationName, onSave = _a.onSave;
    var _b = (0, react_1.useState)(false), showTitleBorder = _b[0], setShowTitleBorder = _b[1];
    var _c = (0, react_1.useState)(false), isEditing = _c[0], setIsEditing = _c[1];
    var handleInputChange = function (e) { return setIntegrationName(e.target.value); };
    var handleBlur = function () {
        setShowTitleBorder(false);
        setIsEditing(false);
        onSave(integrationName);
    };
    var handleFocus = function (event) {
        setIsEditing(true);
        setShowTitleBorder(true);
        setTimeout(function () { return event.target.select(); }, 0);
    };
    var inputStyle = {
        borderBottom: showTitleBorder ? "1px solid #BABABA" : "0px",
        outline: "none",
    };
    return (react_1.default.createElement("div", { className: Integrations_module_css_1.default.editable_integration_container, onMouseEnter: function () { return setIsEditing(true); } },
        react_1.default.createElement("input", { className: "".concat(Integrations_module_css_1.default.editable_input, " ns-font-family-bold"), style: inputStyle, value: integrationName, onChange: handleInputChange, onBlur: handleBlur, onFocus: handleFocus, readOnly: !isEditing, "data-cy": "integrationNameInput" }),
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPen, className: Integrations_module_css_1.default.edit_icon })));
};
var createIntegrationBody = function (integrationType) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    switch (integrationType.name) {
        case "Grafana":
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "ns-font-family my-3", style: { position: "relative", top: "-100px", width: "70%" } },
                    react_1.default.createElement("span", null, t("Insert Grafana report URLs below, remember to add a meaningful name, so you select the correct report on your presentations"))),
                react_1.default.createElement("div", { className: "d-flex flex-column", style: { position: "relative", top: "-100px", gap: "5px" } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faGlobe, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px" } }),
                        react_1.default.createElement("a", { href: "https://nordic-screen.com/grafana/web", style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" }, t("Read more about the Grafana App"))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faMemoCircleInfo, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px", position: "relative", right: "-1.5px" } }),
                        react_1.default.createElement("a", { href: "https://nordic-screen.com/grafana/guide", style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" }, t("Grafana Guide")))),
                react_1.default.createElement("span", { className: "ns-font-family-bold", style: { color: "var(--info-color)", position: "relative", top: "-40px" } },
                    t("Report links"),
                    ":"),
                react_1.default.createElement("div", { className: "ns-font-family my-3", style: { position: "relative", top: "-40px", width: "70%" } },
                    react_1.default.createElement("span", null, t("Clicking on save will start the integration, the process takes a couple of minutes. To see the current status of your integration hover over the indicator icon.")))));
        case "Power Bi":
        default:
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "ns-font-family my-3", style: { position: "relative", top: "-100px", width: "70%" } },
                    react_1.default.createElement("span", null, t("Insert Power BI report URLs below, remember to add a meaningful name, so you select the correct report on your presentations"))),
                react_1.default.createElement("div", { className: "d-flex flex-column", style: { position: "relative", top: "-100px", gap: "5px" } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faGlobe, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px" } }),
                        react_1.default.createElement("a", { href: "https://nordic-screen.com/powerbi/web", style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" }, t("Read more about the Power BI App"))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faMemoCircleInfo, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px", position: "relative", right: "-1.5px" } }),
                        react_1.default.createElement("a", { href: "https://nordic-screen.com/powerbi/guide", style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" }, t("Power BI Guide")))),
                react_1.default.createElement("span", { className: "ns-font-family-bold", style: { color: "var(--info-color)", position: "relative", top: "-40px" } },
                    t("Report links"),
                    ":"),
                react_1.default.createElement("div", { className: "ns-font-family my-3", style: { position: "relative", top: "-40px", width: "70%" } },
                    react_1.default.createElement("span", null, t("Clicking on save will start the integration, the process takes a couple of minutes. To see the current status of your integration hover over the indicator icon.")))));
    }
};
var WebCaptureIntegration = function (props) {
    var _a, _b, _c;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _d = (0, react_1.useState)(function () {
        if (props.mode === "new") {
            return [{ url: "", name: "", width: 3840, height: 2160, uuid: (0, uuid_1.v4)(), isNew: true }];
        }
        else if (props.mode === "edit" && props.integration && typeof props.integration.urls === "string") {
            try {
                return JSON.parse(props.integration.urls);
            }
            catch (error) {
                console.error("Error parsing URLs JSON:", error);
                return [];
            }
        }
        return [];
    }), urls = _d[0], setUrls = _d[1];
    var _e = (0, react_1.useState)(((_a = props.integration) === null || _a === void 0 ? void 0 : _a.email) || ""), email = _e[0], setEmail = _e[1];
    var _f = (0, react_1.useState)(((_b = props.integration) === null || _b === void 0 ? void 0 : _b.password) || ""), password = _f[0], setPassword = _f[1];
    var _g = (0, react_1.useState)(!email), isEmailEmpty = _g[0], setIsEmailEmpty = _g[1];
    var _h = (0, react_1.useState)(!password), isPasswordEmpty = _h[0], setIsPasswordEmpty = _h[1];
    var initialName = props.mode === "new" ? props.integrationType.name : ((_c = props.integration) === null || _c === void 0 ? void 0 : _c.name) || "";
    var _j = (0, react_1.useState)(initialName), integrationName = _j[0], setIntegrationName = _j[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _k = (0, react_1.useState)([]), setNewLinks = _k[1];
    var _l = (0, react_1.useState)(false), shouldFetchNew = _l[0], setShouldFetchNew = _l[1];
    var _m = (0, react_1.useState)({}), isNewMap = _m[0], setIsNewMap = _m[1];
    var _o = (0, react_1.useState)(false), isFormValid = _o[0], setIsFormValid = _o[1];
    var _p = (0, react_1.useState)(false), isSaving = _p[0], setIsSaving = _p[1];
    var _q = (0, react_1.useState)(true), showStatusText = _q[0], setShowStatusText = _q[1];
    var _r = (0, react_1.useState)({}), statusMap = _r[0], setStatusMap = _r[1];
    var updateIntegrationName = function (newName) {
        if (props.setIntegration && props.integration) {
            props.setIntegration(__assign(__assign({}, props.integration), { name: newName }));
        }
    };
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var integrationData, updatedIsNewMap_1, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsSaving(true);
                    setShowStatusText(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    integrationData = {
                        web_capture_integration_id: Number((_a = props.integration) === null || _a === void 0 ? void 0 : _a.web_capture_integration_id),
                        type: props.integrationType.name,
                        name: integrationName,
                        email: email,
                        password: password,
                        urls: urls,
                    };
                    return [4 /*yield*/, props.createIntegration(integrationData)];
                case 2:
                    _b.sent();
                    setUrls(integrationData.urls);
                    updatedIsNewMap_1 = {};
                    integrationData.urls.forEach(function (url) {
                        updatedIsNewMap_1[url.uuid] = isNewMap[url.uuid] || false;
                    });
                    setPassword("");
                    setIsPasswordEmpty(true);
                    setIsNewMap(updatedIsNewMap_1);
                    setShouldFetchNew(true);
                    setTimeout(function () {
                        setShouldFetchNew(false);
                    }, 8000);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    console.error("Error during save:", error_3);
                    setIsSaving(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var addNewReportLink = function () {
        var newUuid = (0, uuid_1.v4)();
        var newUrl = { url: "", name: "", width: 3840, height: 2160, uuid: newUuid, isNew: true };
        setUrls(function (prevUrls) { return __spreadArray(__spreadArray([], prevUrls, true), [newUrl], false); });
        setIsNewMap(function (prevIsNewMap) {
            var _a;
            return (__assign(__assign({}, prevIsNewMap), (_a = {}, _a[newUuid] = true, _a)));
        });
    };
    (0, react_1.useEffect)(function () {
        if (props.creationError) {
            setPassword("");
        }
    }, [props.creationError]);
    var handleDeleteRow = function (indexToDelete) {
        var _a;
        if (urls.length === 1) {
            setUrls([{ url: "", name: "", width: 3840, height: 2160, uuid: (0, uuid_1.v4)() }]);
            setIsNewMap((_a = {}, _a[urls[indexToDelete].uuid] = true, _a));
        }
        else {
            setUrls(function (prevUrls) { return prevUrls.filter(function (_, index) { return index !== indexToDelete; }); });
            setIsNewMap(function (prevIsNewMap) {
                var updatedIsNewMap = __assign({}, prevIsNewMap);
                delete updatedIsNewMap[urls[indexToDelete].uuid];
                return updatedIsNewMap;
            });
        }
    };
    (0, react_1.useEffect)(function () {
        if (props.integration) {
            setEmail(email);
            setPassword(props.integration.password);
            setIntegrationName(integrationName || "");
            if (props.integration.urls && typeof props.integration.urls === "string") {
                try {
                    var parsedUrls = JSON.parse(props.integration.urls);
                    setUrls(parsedUrls);
                }
                catch (error) {
                    logger.error("Error parsing URLs JSON:", error);
                }
            }
        }
        if (props.mode === "new") {
            setPassword("");
            var initialIsNewMap_1 = {};
            urls.forEach(function (url) {
                initialIsNewMap_1[url.uuid] = true;
            });
            setIsNewMap(initialIsNewMap_1);
        }
        if (props.mode === "edit") {
            setShouldFetchNew(false);
            setNewLinks([]);
        }
    }, [props.integration, props.mode]);
    (0, react_1.useEffect)(function () {
        var areUrlsValid = urls.every(function (url) {
            if (url.url && url.url.trim() !== "" && url.name && url.name.trim() !== "") {
                if (!url.width || url.width < 24 || url.width > 7680) {
                    return false;
                }
                if (!url.height || url.height < 24 || url.height > 10000) {
                    return false;
                }
                return true;
            }
            return false;
        });
        var isEmailValid = email && email.trim() !== "";
        var isPasswordValid = password && password.trim() !== "";
        var isIntegrationNameValid = integrationName && integrationName.trim() !== "";
        setIsFormValid(areUrlsValid && isEmailValid && isPasswordValid && isIntegrationNameValid);
    }, [urls, email, password, integrationName]);
    var handleUrlChange = function (index, newUrl) {
        var updatedUrls = urls.map(function (item, i) { return i === index ? __assign(__assign({}, item), { url: newUrl }) : item; });
        setUrls(updatedUrls);
    };
    var handleNameChange = function (index, newName) {
        var updatedUrls = urls.map(function (item, i) { return i === index ? __assign(__assign({}, item), { name: newName }) : item; });
        setUrls(updatedUrls);
    };
    var handleWidthChange = function (index, newWidth) {
        var updatedUrls = urls.map(function (item, i) { return i === index ? __assign(__assign({}, item), { width: parseInt(newWidth) }) : item; });
        setUrls(updatedUrls);
    };
    var handleHeightChange = function (index, newHeight) {
        var updatedUrls = urls.map(function (item, i) { return i === index ? __assign(__assign({}, item), { height: parseInt(newHeight) }) : item; });
        setUrls(updatedUrls);
    };
    var handleStatusChange = function (uuid, status) {
        setStatusMap(function (prevStatusMap) {
            var _a;
            return (__assign(__assign({}, prevStatusMap), (_a = {}, _a[uuid] = status, _a)));
        });
    };
    (0, react_1.useEffect)(function () {
        var allNot425 = Object.values(statusMap).every(function (status) { return status !== 425; });
        setShowStatusText(!allNot425);
    }, [statusMap]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-flex flex-column flex-md-row justify-content-between", style: { gap: "3rem" } },
            react_1.default.createElement("div", { style: { flex: "2 1 9%", maxWidth: "100%" } },
                react_1.default.createElement(EditableIntegrationName, { integrationName: integrationName, setIntegrationName: setIntegrationName, onSave: updateIntegrationName }),
                createIntegrationBody(props.integrationType)),
            react_1.default.createElement("div", { style: { flex: 1, maxWidth: "300dpx", position: "relative", top: "-69px" } },
                react_1.default.createElement(Card_1.default, { variant: "outlined", sx: { boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "70px" } },
                    react_1.default.createElement(CardContent_1.default, null,
                        react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "div", className: "ns-font-family-bold", sx: { color: "var(--info-color)" } },
                            react_1.default.createElement("img", { src: props.integrationType.iconUrl, width: 30, height: 28, alt: props.integrationType.name }),
                            " Log in:"),
                        react_1.default.createElement(material_1.Stack, { gap: 2 },
                            react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isEmailEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                            react_1.default.createElement(q_play_components_1.Input, { type: "email", value: email || "", onChange: function (event) {
                                    setEmail(event.target.value);
                                    setIsEmailEmpty(event.target.value.trim() === "");
                                }, style: { borderRadius: "4px" }, placeholder: t("Username"), dataCy: "webCaptureUsernameInput" }),
                            react_1.default.createElement("div", { className: Integrations_module_css_1.default["validation-message"] }, isPasswordEmpty && react_1.default.createElement("div", null, t("[Required]"))),
                            react_1.default.createElement(q_play_components_1.Input, { type: "password", value: password || "", onChange: function (event) {
                                    var newPassword = event.target.value;
                                    setPassword(newPassword);
                                    setIsPasswordEmpty(newPassword.trim() === "");
                                }, style: { borderRadius: "4px" }, dataCy: "webCapturePasswordInput", placeholder: t("Password") })))))),
        react_1.default.createElement("div", null,
            Array.isArray(urls) && urls.map(function (url, index) {
                var _a;
                return (react_1.default.createElement(ReportLink, { key: url.uuid || index, url: url.url, name: url.name, width: url.width, height: url.height, index: index, onUrlChange: handleUrlChange, onNameChange: handleNameChange, onWidthChange: handleWidthChange, onHeightChange: handleHeightChange, onDelete: handleDeleteRow, uuid: url.uuid, webCaptureIntegrationId: (_a = props.integration) === null || _a === void 0 ? void 0 : _a.web_capture_integration_id, shouldFetchNew: shouldFetchNew, isNew: isNewMap[url.uuid], mode: props.mode, onStatusChange: handleStatusChange }));
            }),
            react_1.default.createElement(q_play_components_1.Button, { variant: "primary", size: "normal", className: "d-flex justify-content-center align-items-center p-0 mt-3", onClick: addNewReportLink, style: { position: "relative", top: "-60px", width: "100%" }, dataCy: "webCaptureAddReportLinkButton" },
                react_1.default.createElement("span", { className: "d-flex justify-content-center align-items-center", style: { height: "40px" } }, "+"))),
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center", style: { marginTop: "1rem" } },
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center", style: { marginTop: "1rem" } },
                react_1.default.createElement("div", { style: { flex: 1 } }, props.creationError ? (react_1.default.createElement("span", { style: { color: "#A71535" } }, t("Failed to save integration. If the error remains please contact +45 71 92 62 22 or support@nordicscreen.com"))) : isSaving && showStatusText && (react_1.default.createElement("span", null, t("Integration has been saved and generating is in process. You can close the modal or wait for it to finish"))))),
            react_1.default.createElement("div", { className: "d-flex justify-content-end", style: { gap: "20px" } },
                react_1.default.createElement(q_play_components_1.Button, { onClick: props.cancelCreation, text: t("Close") }),
                !isFormValid ? (react_1.default.createElement(material_2.Tooltip, { title: t("Please fill out all required fields"), placement: "top", arrow: true },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(q_play_components_1.Button, { variant: "secondary", disabled: true, onClick: save, text: t("Save"), dataCy: "saveIntegrationButton" })))) : (react_1.default.createElement(q_play_components_1.Button, { variant: "secondary", disabled: !isFormValid, onClick: save, text: t("Save"), dataCy: "saveIntegrationButton" }))))));
};
exports.default = WebCaptureIntegration;
